"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Sce_1 = tslib_1.__importDefault(require("../../../index/Sce"));
var Permissions_1 = require("../permissions/Permissions");
var UserPermissions = /** @class */ (function () {
    function UserPermissions() {
    }
    UserPermissions.prototype.hasPermission = function (method) {
        var permissions = Permissions_1.rbacPermissions.rbacPermissions;
        switch (method) {
            //#region Sce Assets
            case Sce_1.default.getSystems: {
                return permissions.isObjectRead;
            }
            case Sce_1.default.getEdges: {
                return permissions.isObjectRead;
            }
            case Sce_1.default.getDevicesConnectivityType: {
                return permissions.isObjectRead;
            }
            case Sce_1.default.getStructures: {
                return permissions.isObjectRead;
            }
            case Sce_1.default.getVariables: {
                return permissions.isObjectRead;
            }
            case Sce_1.default.getObjectByEdge: {
                return permissions.isObjectRead;
            }
            case Sce_1.default.getObjectByEdgeWithPaging: {
                return permissions.isObjectRead;
            }
            case Sce_1.default.systemStructureObjectsDetails: {
                return permissions.isObjectRead;
            }
            case Sce_1.default.systemStructureChildObjectsDetails: {
                return permissions.isObjectRead;
            }
            case Sce_1.default.systemStructureObjects: {
                return permissions.isObjectRead;
            }
            case Sce_1.default.systemStructureChildObjects: {
                return permissions.isObjectRead;
            }
            case Sce_1.default.querySystemStructureObjects: {
                return (permissions.isObjectRead && permissions.isFileDownload);
            }
            case Sce_1.default.queryStructureObjectsPaging: {
                return permissions.isObjectRead;
            }
            case Sce_1.default.getSystemStructureModels: {
                return (permissions.isObjectRead && permissions.isTypeDefRead && permissions.isFileDownload);
            }
            case Sce_1.default.getConnectDetailsFromIdentityModels: {
                return (permissions.isObjectRead && permissions.isTypeDefRead);
            }
            case Sce_1.default.getSystemsBasedOnConnectModel: {
                return (permissions.isObjectRead && permissions.isTypeDefRead);
            }
            case Sce_1.default.getChildObjects: {
                return (permissions.isObjectRead && permissions.isTypeDefRead && permissions.isFileDownload);
            }
            case Sce_1.default.getChildObjectsST: {
                return (permissions.isObjectRead && permissions.isTypeDefRead && permissions.isFileDownload);
            }
            case Sce_1.default.filterObjects: {
                return (permissions.isObjectRead && permissions.isTypeDefRead && permissions.isFileDownload);
            }
            case Sce_1.default.filterSystemStructureObjects: {
                return (permissions.isObjectRead && permissions.isFileDownload);
            }
            case Sce_1.default.filterEdgeObjects: {
                return (permissions.isObjectRead && permissions.isFileDownload);
            }
            case Sce_1.default.getAssetTypes: {
                return (permissions.isObjectRead);
            }
            case Sce_1.default.getAssetModelTypes: {
                return (permissions.isObjectRead);
            }
            case Sce_1.default.deleteObject: {
                return (permissions.isObjectDelete);
            }
            case Sce_1.default.createStrucutreModel: {
                return (permissions.isTypeDefRead && permissions.isTypeDefCreate);
            }
            case Sce_1.default.editStrucutreModel: {
                return (permissions.isTypeDefRead && permissions.isTypeDefWrite);
            }
            case Sce_1.default.deleteStrucutreModel: {
                return (permissions.isTypeDefRead && permissions.isTypeDefDelete);
            }
            case Sce_1.default.cloneStrucutreModel: {
                return (permissions.isTypeDefRead && permissions.isTypeDefCreate);
            }
            case Sce_1.default.getSystemStructureModelNamesAndIdsForTenantExt: {
                return (permissions.isObjectRead && permissions.isTypeDefRead);
            }
            case Sce_1.default.getSystemStructureModelNamesAndIdsForTenantExt2: {
                return (permissions.isObjectRead && permissions.isTypeDefRead);
            }
            case Sce_1.default.getSystemStructureModelsForSpecificTenant: {
                return (permissions.isObjectRead && permissions.isTypeDefRead);
            }
            case Sce_1.default.addStrucutreNode: {
                return (permissions.isTypeDefRead && permissions.isTypeDefCreate);
            }
            case Sce_1.default.editStrucutreNodeName: {
                return (permissions.isTypeDefRead && permissions.isTypeDefWrite);
            }
            case Sce_1.default.deleteStrucutreNode: {
                return (permissions.isTypeDefRead && permissions.isTypeDefDelete);
            }
            //#endregion
            //#region Sce Function Type
            case Sce_1.default.getFunctionsList: {
                return permissions.isTypeDefRead;
            }
            case Sce_1.default.getTypeDetails: {
                return permissions.isTypeDefRead;
            }
            case Sce_1.default.saveFunction: {
                return permissions.isTypeDefWrite;
            }
            case Sce_1.default.importFunctionTypes: {
                return (permissions.isTypeDefRead && permissions.isTypeDefWrite);
            }
            case Sce_1.default.getFunction: {
                return permissions.isTypeDefRead;
            }
            case Sce_1.default.deleteFunction: {
                return permissions.isTypeDefDelete;
            }
            case Sce_1.default.getFunctionType: {
                return permissions.isTypeDefRead;
            }
            case Sce_1.default.getFunctionTypes: {
                return permissions.isTypeDefRead;
            }
            //#endregion
            //#region Sce Instance
            case Sce_1.default.monitorMultipleInstances: {
                var isObjectCreate = permissions.isObjectCreate, isObjectRead = permissions.isObjectRead, isObjectWrite = permissions.isObjectWrite, isFileDownload = permissions.isFileDownload, isFileUpload = permissions.isFileUpload, isFileSearch = permissions.isFileSearch;
                return (isObjectCreate && isObjectRead && isObjectWrite && isFileDownload && isFileUpload && isFileSearch);
            }
            case Sce_1.default.updateExistingInstances: {
                var isObjectCreate = permissions.isObjectCreate, isObjectRead = permissions.isObjectRead, isObjectWrite = permissions.isObjectWrite, isFileDownload = permissions.isFileDownload, isFileUpload = permissions.isFileUpload, isFileSearch = permissions.isFileSearch;
                return (isObjectCreate && isObjectRead && isObjectWrite && isFileDownload && isFileUpload && isFileSearch);
            }
            case Sce_1.default.getInstance: {
                return permissions.isObjectRead;
            }
            case Sce_1.default.deleteMultipleInstances: {
                var isObjectRead = permissions.isObjectRead, isObjectWrite = permissions.isObjectWrite, isObjectDelete = permissions.isObjectDelete, isFileDownload = permissions.isFileDownload, isFileUpload = permissions.isFileUpload, isFileSearch = permissions.isFileSearch;
                return (isObjectDelete && isObjectRead && isObjectWrite && isFileDownload && isFileUpload && isFileSearch);
            }
            case Sce_1.default.disableSingleOrMultipleMonitoringInstances: {
                var isObjectRead = permissions.isObjectRead, isObjectWrite = permissions.isObjectWrite, isFileDownload = permissions.isFileDownload, isFileUpload = permissions.isFileUpload, isFileSearch = permissions.isFileSearch;
                return (isObjectRead && isObjectWrite && isFileDownload && isFileUpload && isFileSearch);
            }
            case Sce_1.default.enableSingleOrMultipleMonitoringInstances: {
                var isObjectRead = permissions.isObjectRead, isObjectWrite = permissions.isObjectWrite, isFileDownload = permissions.isFileDownload, isFileUpload = permissions.isFileUpload, isFileSearch = permissions.isFileSearch;
                return (isObjectRead && isObjectWrite && isFileDownload && isFileUpload && isFileSearch);
            }
            //#endregion
            //#region Sce Type
            case Sce_1.default.getTypes: {
                return permissions.isTypeDefRead;
            }
            case Sce_1.default.getObjectTypeDetails: {
                return permissions.isTypeDefRead;
            }
            case Sce_1.default.saveModel: {
                var isObjectCreate = permissions.isObjectCreate, isObjectRead = permissions.isObjectRead, isObjectWrite = permissions.isObjectWrite, isTypeDefCreate = permissions.isTypeDefCreate, isTypeDefRead = permissions.isTypeDefRead, isTypeDefWrite = permissions.isTypeDefWrite;
                return (isObjectCreate && isObjectRead && isObjectWrite && isTypeDefCreate && isTypeDefRead && isTypeDefWrite);
            }
            case Sce_1.default.getModels: {
                return permissions.isObjectRead;
            }
            case Sce_1.default.deleteModel: {
                var isObjectRead = permissions.isObjectRead, isObjectWrite = permissions.isObjectWrite, isObjectDelete = permissions.isObjectDelete, isTypeDefDelete = permissions.isTypeDefDelete;
                return (isObjectRead && isObjectWrite && isObjectDelete && isTypeDefDelete);
            }
            case Sce_1.default.getSupportedModels: {
                return permissions.isObjectRead;
            }
            case Sce_1.default.getModelStatistics: {
                return permissions.isObjectRead;
            }
            case Sce_1.default.getTypesVersions: {
                return permissions.isTypeDefRead;
            }
            case Sce_1.default.getTypeVersions: {
                return permissions.isTypeDefRead;
            }
            case Sce_1.default.importModels: {
                var isObjectCreate = permissions.isObjectCreate, isObjectRead = permissions.isObjectRead, isObjectWrite = permissions.isObjectWrite, isTypeDefCreate = permissions.isTypeDefCreate, isTypeDefRead = permissions.isTypeDefRead, isTypeDefWrite = permissions.isTypeDefWrite;
                return (isObjectCreate && isObjectRead && isObjectWrite && isTypeDefCreate && isTypeDefRead && isTypeDefWrite);
            }
            case Sce_1.default.createExportableModels: {
                return permissions.isTypeDefRead;
            }
            case Sce_1.default.getAlarmType: {
                return permissions.isTypeDefRead;
            }
            case Sce_1.default.getType: {
                return permissions.isTypeDefRead;
            }
            case Sce_1.default.getEnggSceModels: {
                return permissions.isTypeDefRead;
            }
            //#endregion
            //#region Sce Features
            case Sce_1.default.getTitleLabel: {
                return true;
            }
            case Sce_1.default.isConditionSupported: {
                return true;
            }
            case Sce_1.default.getTypeLabel: {
                return true;
            }
            default: {
                return false;
            }
            //#endregion
        }
    };
    return UserPermissions;
}());
exports.UserPermissions = UserPermissions;
var userPermissions = new UserPermissions();
exports.userPermissions = userPermissions;
//# sourceMappingURL=UserPermissions.js.map